import RFIRouter from './RFI.router';
export { default as rfiRoutes } from './routes';

export default RFIRouter;
